import Cookie from 'cookie';

export async function initAuthState({commit, dispatch}, {req, isPublicRoute}) {
  const cookies = Cookie.parse(req.headers?.cookie || '')
  const haveTokenOrRefreshToken = cookies['userToken'];

  if (haveTokenOrRefreshToken) {
    commit('setLogged', true);
    await dispatch('getUserInfo')
  }

  let workspace = this.$cookies.get('workspace') || 0;
  if (workspace) {
    commit('setWorkspace', workspace)
  }
}

export async function verifyAccount({commit}, active_code = null) {
  return await this.$frontendRepositories.users.verifyAccount(active_code);
}

export async function getCompanies({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.companies();
  if (!errResponse && responseData.success) {
    commit('setCompanies', responseData.data);

    return responseData;
  }

  return [];
}

export async function getUserInfo({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.users.info();
  if (!errResponse && responseData.success) {
    commit('setIsRoleApplication', responseData.data.is_role_application);
    return commit('setUser', responseData.data);
  }

  return {};
}

export async function bridgeLogin({commit, dispatch}, token) {
  this.$cookies.remove('workspace')
}

export async function login({dispatch, commit}, payload) {
  commit('setBtnLoading', true, {root: true});

  let isSuccess = false;
  let message, responseData;
  let resendMail = false;
  let noWorkspace = false;
  const noRedirect = payload?.noRedirect;

  try {
    const {errResponse, data} = await this.$frontendRepositories.users.login({
      email: payload.email,
      password: payload.password,
      deviceToken: payload.deviceToken
    });

    responseData = data;

    if (!errResponse && responseData.success) {
      isSuccess = true;
      const tokenBearer = responseData.data.access_token;

      // remove workspace
      this.$cookies.remove('workspace');
      await dispatch('saveAuth', {tokenBearer});

      const { data: companiesData } = await dispatch('getCompanies');
      dispatch('frontend/calendar/changeNeedShowProposalModal', true, {root:true})

      switch (companiesData.length) {
        case 1:
          const companyId = companiesData[0].id;
          this.$cookies.set('workspace', companyId);

          await commit('setWorkspace', companyId);
          await dispatch('getUserInfo');

          const { errResponse, data: responseData } = await dispatch('getCompanyPreSetting', companyId);
          if (!errResponse) {
            await commit('setCompany', responseData.data);
          }
          
          if (!noRedirect) {
            this.$router.replace('/dashboard');
          }
          break;
        case 0:
          noWorkspace = true;
          isSuccess = false;
          await dispatch('logout');
          break;
        default:
          break;
      }
    } else if (responseData?.data?.register) {
      return responseData;
    }

    message = responseData.message;

    if (noWorkspace) {
      message = 'ユーザは招待されていません。';
    }

    resendMail = responseData?.data?.resend_mail;
  } catch (e) {
    isSuccess = false;

    responseData = e.response.data;
    message = responseData.hasOwnProperty('data')
      ? Object.values(responseData.data)[0][0] || 'Server Error'
      : responseData.message;
  } finally {
    commit('setBtnLoading', false, {root: true});
  }

  commit('setLogin', {
    isSuccess,
    message,
    isAlert: true,
    resendMail
  });

  return responseData;
}

export async function checkPassword({commit}, payload) {
  try {
    return await this.$frontendRepositories.users.checkPassword(payload);
  } catch (e) {
    commit('setErrors', e.response?.data?.data, {root: true});

    return {
      ...e.response?.data?.data || {},
      message: e.response?.data?.message
    }
  }
}

export async function registerEmail({commit}, payload) {
  try {
    return await this.$frontendRepositories.users.registerEmail(payload);
  } catch (e) {
    commit('setErrors', e.response?.data?.data, {root: true});

    return {
      ...e.response?.data?.data || {},
      message: e.response?.data?.message
    }
  }
}

export async function updateUserFirstTimeByToken({commit}, { token, payload}) {
  try {
    return await this.$frontendRepositories.users.updateUserFirstTimeByToken(token, payload);
  } catch (e) {
    commit('setErrors', e.response?.data?.data, {root: true});

    return {
      ...e.response?.data?.data || {},
      message: e.response?.data?.message
    }
  }
}

export async function register({commit}, payload) {
  try {
    return await this.$frontendRepositories.users.register(payload);
  } catch (e) {
    commit('setErrors', e.response?.data?.data, {root: true});

    return {
      ...e.response?.data?.data || {},
      message: e.response?.data?.message
    }
  }
}

export function getCompanyPreSetting(_, companyId) {
  return this.$frontendRepositories.users.getCompany(companyId);
}

export async function logout({commit}) {
  await this.$frontendRepositories.users.logout();
  commit('setToken', null);
  commit('setLogged', false);
  commit('setLogin', {
    isSuccess: true,
    message: '',
    isAlert: false,
  });
  this.$cookies.remove('workspace');
  await commit('hidePageLoading', true, {root: true});
  return true;
}

export async function verifyEmail({commit}, payload) {
  let isSuccess = true;
  let message;

  commit('setBtnLoading', true, {root: true});

  try {
    const response = await this.$frontendRepositories.users.verifyEmail(payload);

    const {errResponse, data: responseData} = response;

    if (errResponse || !responseData.success) {
      isSuccess = false;
    }

    message = responseData.message;

    commit('setLogin', {
      isSuccess,
      message,
      isAlert: true,
      responseData: responseData.data,
    });

    return response;
  } catch (e) {
    isSuccess = false;

    const responseData = e.response.data;
    message = responseData.hasOwnProperty('data') ? Object.values(responseData.data)[0][0] || 'Server Error' : responseData.message;

    commit('setLogin', {
      isSuccess,
      message,
      isAlert: true
    });

    return false;
  } finally {
    commit('setBtnLoading', false, {root: true});
  }
}

export async function verifyEmailChangeEmail(_, token) {
  return await this.$frontendRepositories.users.verifyEmailChangeEmail(token);
}

export async function resetPassword({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.users.resetPassword(payload);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function changePassword({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.users.changePassword(payload);
  if (!response.errResponse && response.data.success) {
    const tokenBearer = response.data.data.access_token;

    await dispatch('saveAuth', {tokenBearer});
  }
  commit('setBtnLoading', false, {root: true});

  return response;
}

export async function resendVerifyMail(_, payload) {
  return await this.$frontendRepositories.users.resendVerifyMail(payload);
}

export async function resendVerifyMailByAuthId(_, payload) {
  return await this.$frontendRepositories.users.resendVerifyMailByAuthId(payload);
}

export async function saveAuth({commit}, payload) {
  const tokenBearer = payload.tokenBearer;
  commit('setToken', tokenBearer);
  commit('setLogged', true);
}

export async function updateNotification({commit}, payload) {
  const response = await this.$frontendRepositories.users.updateNotification({
    notification: payload,
  })

  if (!response.errResponse && response.data.success) {
    commit('updateNotification', payload);
  }
}

export async function updatePaymentStep({commit}, paymentStep) {
  commit('updatePaymentStep', paymentStep)
}
